import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20456539"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["id"]

import { MainTag } from '@functions/model/filter';
import { PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsListMobile',
  props: {
  tag: {
    type: Object as PropType<MainTag>
  }
},
  setup(__props) {

const props = __props;

const expanded = ref(false);



const toggle = () => {
  expanded.value = !expanded.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(__props.tag?.title), 1),
    _createElementVNode("ul", {
      class: "sub-filters",
      id: __props.tag?.id,
      role: "group"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tag?.subTags, (subTag) => {
        return (_openBlock(), _createElementBlock("li", {
          key: subTag.id,
          role: "treeitem",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
        }, [
          _createVNode(_component_router_link, {
            to: { path: '/thema', query: { tag: subTag.id } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(subTag.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 32))
      }), 128))
    ], 8, _hoisted_2)
  ]))
}
}

})